'use strict';
module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/engine-user-agent.js
// module id = 161
// module chunks = 0